import classNames from 'classnames';
import style from './buttonRow.module.scss';
import sharingStyle from 'acscp/components/sharing/sharing.module.scss';
import modificationStyle from 'acscp/components/booking/modificationRequest.module.scss';
import { AppState, Booking } from 'acscp/store';
import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { connect } from 'react-redux';

interface ButtonRowOwnProps {
    bookingDetails: Booking;
    className?: string;
    narrow?: boolean;
}

interface ButtonRowStateProps {
    isLoggedIn: boolean;
}

type ButtonRowProps = ButtonRowOwnProps & ButtonRowStateProps;

const ButtonRowPresentational: React.FC<ButtonRowProps>
    = ({ bookingDetails, className, narrow, isLoggedIn, children }) => {
        const validForModification = (bookingDetails.status === 'CheckingAvailability'
        || bookingDetails.status === 'FlightPlanning'
        || bookingDetails.status === 'ItineraryAvailable')
        && (isLoggedIn || ENABLE_CREATE_ACCOUNT);

        const canShare = isLoggedIn || ENABLE_CREATE_ACCOUNT;

        const rowStyle = validForModification && canShare && (!!children)
            ? style.ThreeButton : undefined;
        narrow = !!narrow;
        return (
            <div className={classNames({ [style.Narrow]: narrow }, style.ButtonRow, className, rowStyle)}>
                { validForModification
                    && <Link
                        to={`/trip/${bookingDetails.id}/modify`}
                        className={modificationStyle.Button}
                    >
                        <FormattedMessage
                            id={'components.buttonrow.modificationButton.text'}
                            defaultMessage={'Change'}
                        />
                    </Link>
                }
                { canShare
                    && <Link
                        to={`/trip/${bookingDetails.id}/share`}
                        className={sharingStyle.Button}
                    >
                        <FormattedMessage id={'components.sharing.shareButton.text'} defaultMessage={'Share'} />
                    </Link>
                }
                {children ? children : null}
            </div>
        );
    };

function mapStateToProps(state: AppState, ownProps: {}): ButtonRowStateProps {
    return {
        isLoggedIn: userIsLoggedIn(state.auth),
    };
}

export const ButtonRow = connect(mapStateToProps)(ButtonRowPresentational);
